module.exports = __webpack_public_path__ + "static/media/circle_dash.9b7e9423.jpg";